export const usernameRegExp = /^(?!-)(?!.*--)[a-z0-9\\-]+[a-z0-9]$/i;
export const emailRegExp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const referralLinkRegex = /^https:\/\/liquidmining\.com\/sign-up\?ref=(?!-)(?!.*--)[a-z0-9-]{2,}$/i;
